import { Action } from '@ngrx/store';

export enum UsersActionTypes {
  GetAllUsers = '[Users] Get GetAllUsers',
  GetAllUsersSuccess = '[Users] Get AllUsers Success',
  GetAllUsersFailure = '[Users] Get AllUsers Failure',
}

export class GetAllUsers implements Action {
  readonly type = UsersActionTypes.GetAllUsers;
  constructor(public payload: any) {}
}

export class GetAllUsersSuccess implements Action {
  readonly type = UsersActionTypes.GetAllUsersSuccess;
  constructor(public payload: any) {}
}

export class GetAllUsersFailure implements Action {
  readonly type = UsersActionTypes.GetAllUsersFailure;
  constructor(public payload: any) {}
}

export type UsersActions =
  GetAllUsers |
  GetAllUsersSuccess |
  GetAllUsersFailure;
